//
// ActiveChapterSlice.js
import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  value: { chapter: null, title: null, activeId: null },
};

export const activeChapterSlice = createSlice({
  name: "activeChapter",
  initialState,
  reducers: {
    activeChapterValue: (state, action) => {
      // action.payload içinden gelen değerleri alıyoruz
      const { chapter, title, activeId } = action.payload;

      // State'i güncelliyoruz
      state.value.chapter = chapter;
      state.value.title = title;
      state.value.activeId = activeId;
    },
  },
});

export const { activeChapterValue } = activeChapterSlice.actions;
export default activeChapterSlice.reducer;
